/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FleetStatisticsListUpdate
 */
export interface FleetStatisticsListUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof FleetStatisticsListUpdate
     */
    vehicleManufacturer?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FleetStatisticsListUpdate
     */
    vehicleSerialNumber?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FleetStatisticsListUpdate
     */
    departmentLabel?: boolean | null;
}

/**
 * Check if a given object implements the FleetStatisticsListUpdate interface.
 */
export function instanceOfFleetStatisticsListUpdate(value: object): value is FleetStatisticsListUpdate {
    return true;
}

export function FleetStatisticsListUpdateFromJSON(json: any): FleetStatisticsListUpdate {
    return FleetStatisticsListUpdateFromJSONTyped(json, false);
}

export function FleetStatisticsListUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FleetStatisticsListUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleManufacturer': json['vehicleManufacturer'] == null ? undefined : json['vehicleManufacturer'],
        'vehicleSerialNumber': json['vehicleSerialNumber'] == null ? undefined : json['vehicleSerialNumber'],
        'departmentLabel': json['departmentLabel'] == null ? undefined : json['departmentLabel'],
    };
}

export function FleetStatisticsListUpdateToJSON(json: any): FleetStatisticsListUpdate {
    return FleetStatisticsListUpdateToJSONTyped(json, false);
}

export function FleetStatisticsListUpdateToJSONTyped(value?: FleetStatisticsListUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleManufacturer': value['vehicleManufacturer'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'departmentLabel': value['departmentLabel'],
    };
}

